import { BaseComponent } from './base.component';
import { NotificationService } from '../services/notification.service';

export abstract class TableComponent<T> extends BaseComponent {

  constructor(public notifService: NotificationService) {
    super(notifService);
  }

}